import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS, fadeUp } from "./content";

export default function Faq() {
  return (
    <section id="faq" className="py-24 md:py-36 bg-bone" data-testid="faq-section">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <motion.div
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-100px" }}
            variants={fadeUp}
            className="lg:col-span-4"
          >
            <span className="overline text-ink-soft">FAQ</span>
            <h2 className="mt-5 font-display text-4xl sm:text-5xl tracking-tight leading-[1.03] text-forest">
              Locum ANP &amp; GP locum questions.
            </h2>
            <p className="mt-6 text-ink-soft leading-relaxed">
              Common questions about primary care locum cover, remote triage and clinical
              workflow systems.
            </p>
          </motion.div>

          <motion.div
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-80px" }}
            variants={fadeUp}
            custom={1}
            className="lg:col-span-8"
          >
            <Accordion type="single" collapsible className="w-full">
              {FAQS.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="border-b border-surface-alt"
                  data-testid={`faq-item-${i}`}
                >
                  <AccordionTrigger className="text-left font-display text-xl md:text-2xl tracking-tight text-forest hover:no-underline py-6">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-ink-soft leading-relaxed text-base pb-6">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
